import Swal from "sweetalert2";
import { t } from "i18next";

const linkState = {
  active: false,
  termId: null
};

export const setPreDriCreateActive = (active) => {
  linkState.active = Boolean(active);
  if (!linkState.active) {
    linkState.termId = null;
  }
};

export const setPreDriTermId = (termId) => {
  const parsed = Number(termId);
  linkState.termId = Number.isInteger(parsed) && parsed > 0 ? parsed : null;
};

export const attachPreDriTermOrWarn = (payload) => {
  if (!linkState.active) {
    return payload;
  }
  if (!linkState.termId) {
    Swal.fire(
      t("titles.error"),
      t(
        "specialist.selection.dri.term-required",
        "Debe seleccionar el término clave asignado a su usuario para guardar el DRI."
      ),
      "warning"
    );
    return null;
  }
  return {
    ...payload,
    feeder_term_id: linkState.termId
  };
};
